var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type)?_c('CoreImage',{attrs:{"image":_vm.asset,"optimiseImages":_vm.optimiseImages,"imgClass":_vm.mergeAssetClass}}):_c('div',[_c('CoreVideo',{class:_vm.mergeAssetClass,attrs:{"video":_vm.asset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }